import { Segment } from '@fxtr/i18n';

export const DEFAULT_SEGMENT = Segment.Fixter_UK;
